/* eslint-disable
    goodeggs/lodash-prefer-is-nil,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'lodash';
import procurementScheduleEnums from 'goodeggs-purchase-orders-sdk/procurement_schedule/enums';

export default ngInject(function() {
  this.daysOfWeek = procurementScheduleEnums.daysOfWeek;

  this.deliversOnDay = (dayOfWeek) =>
    __guard__(
      __guard__(
        this.procurementSchedule != null ? this.procurementSchedule.dropoffDays : undefined,
        (x1) => x1[dayOfWeek],
      ),
      (x) => x.enabled,
    ) != null
      ? __guard__(
          __guard__(
            this.procurementSchedule != null ? this.procurementSchedule.dropoffDays : undefined,
            (x1) => x1[dayOfWeek],
          ),
          (x) => x.enabled,
        )
      : false;

  return this;
});
function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
